import '../../components/styles/customstyle.scss'

import * as sync from '../../../src/syncWorker'

import { AVAILABLE_ENTITIES, Repository, utils } from '../../database'
import { Container, Grid } from '@material-ui/core'
import React, { Component } from 'react'
import { USUARIO, formatName } from '../../utils/formHelper'

import Button from '../../components/material/Button'
import clearStorage from '../../utils/clearStorage'
import { connect } from 'react-redux'
import { getLoggedUser } from '../../redux/auth/actions'
import { logout } from '../../redux/auth/actions'
import { withRouter } from 'react-router-dom'

class Backup extends Component {
  constructor(props) {
    super(props)


    this.state = {
    }

    this.exitApplication = this.exitApplication.bind(this)


  }

  downloadBackup() {
    sync.downloadBackup(formatName('props.user.nomeCompleto', USUARIO))
  }

  async exitApplication() {
    const result = await clearStorage(this.props.currentSync)
    if (!result.success) {
      if (result.reason === 'OFFLINE_WITH_PENDING_DATA') {
        alert(`Não é possível sair: você está offline e possui ${result.pendingCount || 'alguns'} registros pendentes de sincronização. Conecte-se à internet primeiro.`)
        return
      } else if (result.reason === 'SYNC_INCOMPLETE') {
        alert(`Ainda existem ${result.pendingCount} registros pendentes. Aguarde a sincronização completar.`)
        return
      } else if (result.reason === 'SYNC_FAILED') {
        alert('Erro ao sincronizar dados. Verifique sua conexão e tente novamente.')
        return
      }
      // Fallback para qualquer outro erro desconhecido
      console.error('[Backup] Erro desconhecido no logout:', result)
      alert('Erro ao sair. Tente novamente.')
      return
    }
    this.props.logout()
    this.props.history.push("/login");
  }

  render() {

    return (
      <Container>
        <div style={{ marginTop: '20px' }}>
          <Button label="backup" onClick={() => this.downloadBackup()} />
          <Button style={{ marginLeft: '20px' }} label="sair" onClick={() => this.exitApplication()} />
        </div>

      </Container>
    )
  }
}


const mapDispatchToProps = dispatch => {
  return {
    logout: async () => await dispatch(logout()),
    loggedUser: async () => await getLoggedUser(),
    user: async () => await utils.getElement(
      AVAILABLE_ENTITIES.USERS,
      loggedUser.userId
    )
  }
}

const mapStateToProps = state => ({
  currentSync: state.sync.currentStatus
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Backup))
